import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Heading,
  IconButton,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useEffect } from "react";
import {
  Action,
  ActionTypes,
  setActionIndex,
} from "../../Store/ActionsHistoryReducer";
import { useAppDispatch, useAppSelector } from "../../Store/hooks";
import {animateScroll} from 'react-scroll';

const HistoryItem = (props: Action & { index: number }) => {
  const dispatch = useAppDispatch();

  const mapActionTypes = () => {
    switch (props.type) {
      case ActionTypes.SET_ROTATION:
        return `Вращение ${props.data.rotate?.from} => ${props.data.rotate?.to}`;
      case ActionTypes.SET_OFFSET:
        return `Перемещение по ${props.data.offset?.axis.toUpperCase()} на ${
          props.data.offset?.distance
        }`;
      case ActionTypes.MIRROR:
        return `Отражение по ${props.data.mirror?.axis}`;
      case ActionTypes.ADD_MODEL:
        return `Добавление модели`;
      case ActionTypes.REPLACE_MODEL:
        return `Замена модели`;
      case ActionTypes.REMOVE_MODEL:
        return `Удаление модели`;
      case ActionTypes.DOUBLE:
        return `Дублирование`;
      case ActionTypes.SET_SIZE:
        return `Изменение размера`;
      case ActionTypes.GROUP:
        return `Группировка`;
      case ActionTypes.LOAD_PROJECT:
        return `Загрузка проекта`;
      case ActionTypes.SET_TEXTURE:
        return `Смена текстуры`;
      default:
        return "Неизвестное действие";
    }
  };
  const actionsIndex = useAppSelector(
    (state) => state.actionsHistory.actionsIndex
  );
  const styles: any = {};
  const setAction = () => {
    dispatch(setActionIndex(props.index));
  };
  if (props.index > actionsIndex) styles.color = "gray";
  return (
    <Text onClick={setAction} style={styles} cursor="pointer" padding="1px">
      {mapActionTypes()}
    </Text>
  );
};

const ActionsHistory = (props: {}) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const actionsHistory = useAppSelector(
    (state) => state.actionsHistory.actions
  );
 
  const scrollToBottom = () => {
    animateScroll.scrollToBottom({
      containerId: "actions-holder"
    });
  }
  
  useEffect(() => scrollToBottom());

  return (
    <Box pos="relative" w="100%">
      <Heading
        cursor="pointer"
        size="md"
        variant="editor"
        textAlign="center"
        onClick={onToggle}
      >
        История действий
      </Heading>
      <IconButton
        pos="absolute"
        top={".5rem"}
        right={".5rem"}
        icon={
          isOpen ? (
            <ChevronUpIcon boxSize={"3rem"} />
          ) : (
            <ChevronDownIcon boxSize={"3rem"} />
          )
        }
        aria-label={isOpen ? "Свернуть" : "Раскрыть"}
        onClick={onToggle}
      />
      <Collapse
        unmountOnExit={false}
        in={isOpen}
        animateOpacity
        startingHeight={0}
      >
        <VStack align="flex-start" maxH="45vh" overflowY="scroll" id="actions-holder">
        {actionsHistory.map((action: Action, index: number) => (
          <HistoryItem {...action} key={`action${index}`} index={index} />
        ))}
        </VStack>
      </Collapse>
    </Box>
  );
};

export default ActionsHistory;
